/**
 * schema.js
 * based on @kitconcept/volto-blocks-grid v7.0.0
 * @nk24 2023/03/06
 */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  ou_grid_2: {
    id: 'Ou Grid 2',
    defaultMessage: 'Ou Grid 2',
  },
  show_separator: {
    id: 'Show separator',
    defaultMessage: 'Show separator',
  },
});

export const GridSchema = (props) => {
  const { intl } = props;
  return {
    title: intl.formatMessage(messages.ou_grid_2),
    // title: 'Ou Grid 2',
    block: '__grid',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },
    ],

    properties: {},
    required: [],
  };
};
